import React from 'react';

// Shared empty and error state (FECOA-2174).
const EmptyState = ({ icon: Icon, title, description, action, tone = 'neutral', className = '' }) => (
  <div className={`flex flex-col items-center justify-center px-6 py-12 text-center ${className}`}>
    {Icon && (
      <Icon
        className={`mb-3 h-6 w-6 ${tone === 'danger' ? 'text-danger-500 dark:text-danger-400' : 'text-gray-400 dark:text-gray-500'}`}
        strokeWidth={1.75}
        aria-hidden="true"
      />
    )}
    {title && <h3 className="text-sm font-semibold text-gray-900 dark:text-gray-50">{title}</h3>}
    {description && <p className="mt-1 max-w-sm text-sm text-gray-500 dark:text-gray-400">{description}</p>}
    {action && <div className="mt-5">{action}</div>}
  </div>
);

export default EmptyState;
